export * from "./Store.js";
export * from "./Subject.js";
export * from "./BehaviorSubject.js";
export * from "./ReplaySubject.js";
export * from "./ReplayForwardSubject.js";
export * from "./Observable.js";
export * from "./Subscription.js";
export * from "./AutoCloseSubscription.js";
export * from "./internal/index.js";
const debounceTimeIntervalLock = (unlockChecker, unlocked, intervalTime, config) => {
  const clearIntervalFn = config?.clearInterval || clearInterval;
  const setIntervalFn = config?.setInterval || setInterval;
  const nextIntervalId = setIntervalFn(() => {
    if (unlockChecker()) {
      clearIntervalFn(nextIntervalId);
      unlocked();
    }
  }, intervalTime);
  return nextIntervalId;
};
const debounce = (fn, delay, config) => {
  const setTimeoutFn = config?.setTimeout || setTimeout;
  const clearTimeoutFn = config?.clearTimeout || clearTimeout;
  let timer = null;
  return (data) => {
    if (timer) {
      clearTimeoutFn(timer);
    }
    timer = setTimeoutFn(() => {
      fn(data);
      timer = null;
    }, delay);
  };
};
const throttleTime = (fn, delay, config) => {
  const setTimeoutFn = config?.setTimeout || setTimeout;
  let timer = null;
  return (...args) => {
    if (!timer) {
      timer = setTimeoutFn(() => {
        fn(...args);
        timer = null;
      }, delay);
    }
  };
};
const throttle = (fn, delay) => {
  let lastTime = 0;
  return (...args) => {
    const now = Date.now();
    if (now - lastTime >= delay) {
      fn(...args);
      lastTime = now;
    }
  };
};
export {
  debounce,
  debounceTimeIntervalLock,
  throttle,
  throttleTime
};
//# sourceMappingURL=index.js.map
